import React from 'react';
import classNames from 'classnames';
import FilterIcon from 'icons/Filter.icon';
import { Button } from 'ncoded-component-library';

import './EditColumnsVisibilityButton.styles.scss';
import './EditColumnsVisibilityButton.styles.responsive.scss';

type EditColumnsVisibilityButtonProps = {
  className?: string;
  onClick: () => void;
};

const EditColumnsVisibilityButton: React.FC<
  EditColumnsVisibilityButtonProps
> = (props) => {
  const { className, onClick } = props;

  const classes = classNames('edit-columns-visibility-button', className);

  return (
    <Button
      className={classes}
      icon={FilterIcon}
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
    />
  );
};

export default EditColumnsVisibilityButton;
